module.exports = __webpack_public_path__ + "static/media/virgo.4ef3ec1e.svg";